import { z } from "zod"

export const baseResponseSchema = z
  .object({
    message: z.string().optional(),
    error: z.union([z.string(), z.number()]).optional(),
  })
  .passthrough()

export const apiResponseSchema = <T extends z.ZodTypeAny>(dataSchema: T) =>
  baseResponseSchema.extend({
    data: dataSchema,
  })

export const paginatedResponseSchema = <T extends z.ZodTypeAny>(
  itemSchema: T
) =>
  baseResponseSchema.extend({
    data: z.array(itemSchema),
    totalPages: z.number().optional(),
    pageSize: z.number().optional(),
    totalItems: z.number().optional(),
    totalCount: z.number().optional(),
  })

export const listResponseSchema = <T extends z.ZodTypeAny>(itemSchema: T) =>
  baseResponseSchema.extend({
    data: z.array(itemSchema),
  })
